import type { JSONContent } from '@tiptap/core';
import { v4 as uuid } from 'uuid';
import { ContentBlockType, DataDisplayBlock } from '../../model';
import { BlockToTiptapConverter } from '../blocks-to-tiptap.converter';

export const convertDataDisplayBlockToTiptap = ((block) => {
  return {
    type: 'dataDisplay',
    attrs: {
      id: block.id,
      data: block.data,
      ...(block.sorted !== undefined && { sorted: block.sorted }),
      ...(block.custom_css && { custom_css: block.custom_css }),
      ...(block.custom_style && { custom_style: block.custom_style }),
    },
  };
}) satisfies BlockToTiptapConverter<DataDisplayBlock>;

export function convertTiptapToDataDisplayBlock(json: JSONContent): DataDisplayBlock {
  const attrs = json.attrs ?? {};

  return {
    id: (attrs['id'] as string) ?? uuid(),
    type: ContentBlockType.DataDisplay,
    data: (attrs['data'] as string) ?? '',
    ...(attrs['sorted'] !== undefined && { sorted: attrs['sorted'] as boolean }),
    ...(attrs['custom_css'] && { custom_css: attrs['custom_css'] as string }),
    ...(attrs['custom_style'] && { custom_style: attrs['custom_style'] as Record<string, string> }),
  };
}
